import React from "react";
import './Headline.css'

function Headline() {
    return (
        <div className='headline'>
            <div className='headlineTitle'><b>Vodafone Identity Hub</b> <br/>Demo.</div>
        </div>
    )
}

export default React.memo(Headline);